export default "/_next/static/images/9fe9092659c5aa0d53e6bf0499ba3589.png";